export const formatUAH = (n) =>
  new Intl.NumberFormat("uk-UA", { style: "currency", currency: "UAH", maximumFractionDigits: 0 })
    .format(n)
    .replace("UAH", "₴")
    .trim();
